import ApiService from '../../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            form: {
                photo: null,
                photo_inside: false,
                photo_label: '',
                published_at: '',
                title: '',
                meta_title: '',
                external_link: '',
                slug: '',
                locale: window.laravel.locale,
                published: true,
                short_description: '',
                meta_description: '',
                description: '',
                author: '',
                imagesInDescription: [],
                tags: [],
                categories: [],
                meta_keywords: '',
                author_fio: '',
                author_photo: null,
            },
            redirect: null,
        }
    },
    getters: {
        form: (state) => state.form,
        tags: (state) => state.form.tags,
        redirect: (state) => state.redirect,

    },
    mutations: {
        setForm(state, value) {
            window.Vue.set(state, 'form', value);
        },
        pushTag(state, value) {
            state.form.tags.push(value);
        },
        setRedirect(state, value) {
            window.Vue.set(state, 'redirect', value);
        },
        clearRedirect(state) {
            window.Vue.set(state, 'redirect', null);
        },
    },
    actions: {
        createArticle({state}, payload) {
            return new Promise((resolve, reject) => {
                ApiService.post('/admin/article', payload)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        editArticle({state}, payload) {
            return new Promise((resolve, reject) => {
                ApiService.update('/admin/article/'+payload.id, payload)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getArticle({state, commit}, articleId) {
            return new Promise((resolve, reject) => {
                ApiService.get('/admin/article', { id: articleId })
                    .then((response) => {
                        resolve(response);
                        commit('setForm', response.data.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        clearForm({state}) {
            let properties = {
                photo: null,
                photo_inside: false,
                published: true,
                categories: [],
            };

            let ignoreProperties = [
                'locale'
            ];

            Object.keys(state.form)
                .filter(property => !ignoreProperties.includes(property))
                .forEach((property) => {
                    if (properties.hasOwnProperty(property)) {
                        state.form[property] = properties[property];
                    } else {
                        state.form[property] = '';
                    }
                });
        },
        getTags({}, payload) {
            return new Promise((resolve, reject) => {
                ApiService.get('/moments/tags', payload)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
    }
};
